import { render, staticRenderFns } from "./expreimburs.vue?vue&type=template&id=0970564f"
import script from "./expreimburs.vue?vue&type=script&lang=js"
export * from "./expreimburs.vue?vue&type=script&lang=js"
import style0 from "./expreimburs.vue?vue&type=style&index=0&id=0970564f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports